__turbopack_context__.v({
  "card": "WhosItFor-module__xVcowG__card",
  "cardSubtitle": "WhosItFor-module__xVcowG__cardSubtitle",
  "cardText": "WhosItFor-module__xVcowG__cardText",
  "cardTitle": "WhosItFor-module__xVcowG__cardTitle",
  "cards": "WhosItFor-module__xVcowG__cards",
  "fadedOverlay": "WhosItFor-module__xVcowG__fadedOverlay",
  "grid": "WhosItFor-module__xVcowG__grid",
  "headingSubtitle": "WhosItFor-module__xVcowG__headingSubtitle",
  "headingTitle": "WhosItFor-module__xVcowG__headingTitle",
  "headingWrap": "WhosItFor-module__xVcowG__headingWrap",
  "icon": "WhosItFor-module__xVcowG__icon",
  "iconImage": "WhosItFor-module__xVcowG__iconImage",
  "inner": "WhosItFor-module__xVcowG__inner",
  "section": "WhosItFor-module__xVcowG__section",
});
